export const API = {
  // BASE_URL: "http://localhost:8005/mentor-academy/",
  BASE_URL: "https://webserver.meantoir.com/mentor-academy/",

  ADMIN_LOGIN: "admin/adminlogin",
  PASSWORD_UPDATE_ADMIN: "admin/update-password",
  RAZORPAY_CREATE_ORDER: "razorpay/createOrder",
  // aws 
  AWS_KEY: "aws/credentials",
  //Contact Form 
  CREATE_CONTACT_FORM: "contactForm/createContactForm",

  //Contact Information
  GET_ALL_CONTACT_INFORMATION: "contactForm/listingContactForm",


  //category management
  GET_ALL_CATEGORIES: "category/listingCategory",
  GET_CATEGORY_BY_ID: "category/find_oneCategory/",
  CREATE_CATEGORY: "category/createCategory",
  UPDATE_CATEGORY: "category/updateCategory/",
  DELETE_CATEGORY: "category/deleteCategory/",

  //course management
  GET_ALL_COURSES: "course/listingCourse",
  GET_COURSE_BY_ID: "course/find_oneCourse/",
  GET_COURSE_BY_SUB_TITLE: "course/find_onesubCourse/",
  CREATE_COURSE: "course/createCourse",
  UPDATE_COURSE: "course/updateCourse/",
  DELETE_COURSE: "course/deleteCourse/",
  FILTER_COURSE: "course/filterCourse",


  // course module management
  GET_ALL_COURSE_MODULES: "course_module/listingCourse_module",
  GET_COURSE_MODULE_BY_ID: "course_module/find_oneCourse_module/",
  CREATE_COURSE_MODULE: "course_module/createCourse_module",
  UPDATE_COURSE_MODULE: "course_module/updateCourseModule/",
  DELETE_COURSE_MODULE: "course_module/deleteCoursemodule/",
  FILTER_COURSE_MODULE: "course_module/filterCourseModule",

  // course outline management
  GET_ALL_COURSE_OUTLINES: "courseOutline/listingCourseOutline",
  GET_COURSE_OUTLINE_BY_ID: "courseOutline/find_oneCourseOutline/",
  CREATE_COURSE_OUTLINE: "courseOutline/createCourseOutline",
  UPDATE_COURSE_OUTLINE: "courseOutline/updateCourseOutline/",
  DELETE_COURSE_OUTLINE: "courseOutline/deleteCourseOutline/",
  FILTER_COURSE_OUTLINE: "courseOutline/filterCourseOutline",

  // course exam management
  GET_ALL_COURSE_EXAMS: "examInformation/listingExamInformation",
  GET_COURSE_EXAM_BY_ID: "examInformation/find_oneExamInformation/",
  CREATE_COURSE_EXAM: "examInformation/createExamInformation",
  UPDATE_COURSE_EXAM: "examInformation/updateExamInformation/",
  DELETE_COURSE_EXAM: "examInformation/deleteExamInformation/",
  FILTER_COURSE_EXAM: "examInformation/filterExamInformation",

  // course enquiry management
  GET_ALL_COURSE_ENQUIRIES: "enquiries/listingEnquiries",
  // GET_COURSE_ENQUIRY_BY_ID: "courseEnquiry/find_oneCourseEnquiry/",
  CREATE_COURSE_ENQUIRY: "enquiries/createEnquiry",
  // UPDATE_COURSE_ENQUIRY: "courseEnquiry/updateCourseEnquiry/",
  DELETE_COURSE_ENQUIRY: "enquiries/deleteEnquiry/",
  FILTER_COURSE_ENQUIRY: "enquiries/filterEnquiry",

  // course eligibility management
  GET_ALL_COURSE_ELIGIBILITY: "eliginilityCheck/listingEligibilityCheck",
  // GET_COURSE_ELIGIBILITY_BY_ID: "courseEligibility/find_oneCourseEligibility/",
  CREATE_COURSE_ELIGIBILITY: "eliginilityCheck/createEligibilityCheck",
  // UPDATE_COURSE_ELIGIBILITY: "courseEligibility/updateCourseEligibility/",
  DELETE_COURSE_ELIGIBILITY: "eliginilityCheck/deleteEligibilityCheck/",
  FILTER_COURSE_ELIGIBILITY: "eliginilityCheck/filterEligibilityCheck",

  // course booking management
  GET_ALL_BOOKING_DETAILS: "bookingdetails/listingBookingDetails",
  GET_BOOKING_DETAILS_BY_ID: "bookingDetails/find_oneBookingDetails/",
  CREATE_BOOKING_DETAILS: "bookingdetails/createBookingDetails",
  UPDATE_BOOKING_DETAILS: "bookingdetails/updateBookingDetails/",
  DELETE_BOOKING_DETAILS: "bookingDetails/deleteBookingDetails/",
  FILTER_BOOKING_DETAILS: "bookingdetails/filterBookingDetails",
  //booking details admin
  BOOKING_DETAILS_ADMIN: "admin/countdata",

  // course payment management

  CREATE_PAYMENT_DETAILS: "paymentDetails/createPaymentDetails",
  GET_ALL_PAYMENT_DETAILS: "paymentDetails/listingPaymentDetails",
};
